import { cloneDeep } from 'lodash';
import {
  batchTransferBudgetRecord,
  budgetMatchExecute,
  frozenBudgetRecord,
  getBudgetRecordLog,
  importEpBudgetFillSubmit,
  recordSubmitCheck,
  transferBudgetRecord,
  unFrozenBudgetRecord,
} from '../services';

export default {
  namespace: 'budgetPlanning',
  state: {
    // 填报单 / 年度预算状态
    budgetOrderStatus: {},
    authButton: {},
    lastSaveTime: undefined,
    // 刷新工作流 + 状态 + 列表
    refreshFlag: false,
    pageLoading: false,
    orderNo: null,
    attachmentList: [],
    validateFlag: false, // 校验浮动比例
  },
  effects: {
    // 重置数据
    *resetData(_, { put }) {
      yield put({
        type: 'update',
        payload: {
          // 填报单 / 年度预算状态
          budgetOrderStatus: {},
          authButton: {},
          lastSaveTime: undefined,
          orderNo: null,
          // 刷新工作流 + 状态 + 列表
          refreshFlag: false,
          pageLoading: false,
        },
      });
    },
    // 设置填报单 / 年度预算状态
    *setBudgetOrderStatus({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: {
          budgetOrderStatus: {
            ...payload,
            status: payload?.auditStatus || payload?.pushed,
            statusDesc: payload?.auditStatusDesc || payload?.pushedDesc,
          },
        },
      });
    },
    *updateAttachments({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: {
          attachmentList: payload,
        },
      });
    },
    *refreshAll({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: {
          refreshFlag: cloneDeep(Boolean(payload)),
        },
      });
    },
    *setPageLoading({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: {
          pageLoading: cloneDeep(Boolean(payload)),
        },
      });
    },
    *setValidateFlag({ payload }, { put }) {
      yield put({
        type: 'update',
        payload: {
          validateFlag: cloneDeep(Boolean(payload)),
        },
      });
    },
    // 日志查询
    *getBudgetRecordLog({ payload }, { call }) {
      return yield call(getBudgetRecordLog, payload);
    },
    // 冻结
    *frozenBudgetRecord({ payload }, { call }) {
      return yield call(frozenBudgetRecord, payload);
    },
    // 解冻
    *unFrozenBudgetRecord({ payload }, { call }) {
      return yield call(unFrozenBudgetRecord, payload);
    },
    // 结转
    *transferBudgetRecord({ payload }, { call }) {
      return yield call(transferBudgetRecord, payload);
    },
    // 预算余额结转
    *batchTransferBudgetRecord({ payload }, { call }) {
      return yield call(batchTransferBudgetRecord, payload);
    },
    // 预算项目填报-提交校验
    *recordSubmitCheck({ payload }, { call }) {
      return yield call(recordSubmitCheck, payload);
    },
    // 导入填报记录（预算填报页面）
    *importEpBudgetFillSubmit({ payload }, { call }) {
      return yield call(importEpBudgetFillSubmit, payload);
    },
    // 预算匹配
    *budgetMatchExecute({ payload }, { call }) {
      return yield call(budgetMatchExecute, payload);
    },
  },
  reducers: {
    update(state, { payload }) {
      return {
        ...state,
        ...payload,
      };
    },
  },
};
